import { useState } from "react";
import { promptInstall, useInstallState } from "../lib/pwa.ts";
import { messages } from "../i18n/index.ts";

const DISMISS_KEY = "mk:install-dismissed";

/** Ana ekrana ekleme daveti. Bir kez kapatılırsa bir daha gösterilmez. */
export function InstallCard() {
  const state = useInstallState();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === "1");

  if (state === "unavailable" || dismissed) return null;

  function dismiss() {
    localStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  }

  return (
    <div className="install-card">
      <div className="flex-1">
        <p className="install-card__title">{messages.install.title}</p>
        <p className="install-card__desc">
          {state === "prompt"
            ? messages.install.prompt
            : messages.install.ios}
        </p>
      </div>
      <div className="flex flex-none items-center gap-1.5">
        {state === "prompt" && (
          <button
            type="button"
            className="chip-btn chip-btn--primary"
            onClick={() => {
              void promptInstall().then((accepted) => {
                if (accepted) dismiss();
              });
            }}
          >
            {messages.install.install}
          </button>
        )}
        <button type="button" className="btn-ghost" onClick={dismiss} aria-label={messages.common.close}>
          ✕
        </button>
      </div>
    </div>
  );
}
